export class StartRide {
 public bookingTripSummaryId: number;
 public contractTypeGroupId: number;
 public startDateTime: string;
 public startLatitude: number;
 public startLongitude:number;
 public startMileage:number;
 public bookingHashId:string;
 public locationExchangeHashId: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/StartRide.ts